module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "media",
    class: {
      'is-unread': !_vm.notif.read
    },
    on: {
      "click": _vm.goToNotif
    }
  }, [(_vm.notif.sender.player) ? _c('figure', {
    staticClass: "media-left"
  }, [_c('player-avatar', {
    attrs: {
      "player": _vm.notif.sender.player
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "media-content"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.$t('notifications.' + _vm.notif.action, {
        name: _vm.name,
        data: _vm.$sanitize(_vm.context_data)
      }))
    }
  }), _vm._v(" "), _c('p', [_c('time', [_vm._v(_vm._s(_vm._f("moment")(_vm.notif.created_at, "from", "now")))])])])]), _vm._v(" "), (_vm.notif.context_type === 'hits') ? _c('figure', {
    staticClass: "media-right"
  }, [_c('p', {
    staticClass: "image is-24x24"
  }, [_c('img', {
    attrs: {
      "src": _vm.imgs[_vm.lower_type]
    }
  })])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-23025a99","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Notifications/Item.vue
// module id = 351
// module chunks = 9